import types from "./ReportActionTypes";

const initialState = {
};

const ReportReducer = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
}

export default ReportReducer;